import complaintAdmHtml from './complaintAdm.html';
import complaintAdmModalNewOrderHtml from './modalsAdm/complaintAdmModalNewOrder.html';
import complaintAdmModalNewOrderController from './modalsAdm/complaintAdmModalNewOrder.controller';

class complaintAdmController {
    constructor($scope, $http, $timeout, ModalService, translateService) {
        'ngInject';

        this.$scope = $scope;
        this.$http = $http;
        this.$timeout = $timeout;
        this.modalService = ModalService;
        this.translate = translateService;

        this.loading = true;
        this.error = false;
        this.success = false;
        this.complainLoaded = false;

        this.complaintId = null;

        this.complaint = null;
        this.order = null;
        this.editable = false;


        this.note = null;
        this.noteFiles = [
            {
                file: null
            }
        ];

        this.message = null;
        this.messageFiles = [
            {
                file: null
            }
        ];

        this.allowedMimeTypes = ['image/jpeg', 'image/gif', 'image/png', 'application/pdf', 'application/x-pdf', 'application/acrobat', 'applications/vnd.pdf', 'text/pdf', 'text/x-pdf', 'application/postscript'];
        this.allowedExtensions = ['jpg', 'jpeg', 'gif', 'png', 'pdf', 'ai'];
        this.messageError = false;
        this.messageSuccess = false;

        this.products = [];
        this.shipments = [];
        this.reasons = [];

        this.createdOrders = [];

        $scope.$watch(() => this.complaintId, (newVal, oldVal) => {
            if (newVal === null) {
                return;
            }

            this.init();
        });
    }

    init() {
        this.$http.post('/admpanel/ajax/complaints/getComplaint', {complaint_id: this.complaintId}, {
            headers: {'Content-Type': 'application/json'}
        }).then(
            (response) => {
                this.loading = false;
                if (response.data.status === 'error') {
                    this.error = response.data.message;
                    $('html,body').animate({ scrollTop: 0 }, 'slow');

                    this.$timeout(() => {
                        this.error = false;
                        window.location.pathname = 'admpanel/complaints';
                    }, 5000);
                } else {
                    this.complaint = response.data.complaint;
                    this.order = response.data.order;
                    this.products = response.data.products;
                    this.shipments = response.data.shipments;
                    this.reasons = response.data.reasons;
                    this.createdOrders = response.data.created_orders;
                    this.complainLoaded = true;
                    this.editable = response.data.editable;
                }
            },
            () => {
                this.loading = false;

                this.error = this.translate.t('admpanel.general.unexpectedErrorHasOccurred');
                $('html,body').animate({ scrollTop: 0 }, 'slow');

                this.$timeout(() => {
                    this.error = false;
                    window.location.pathname = 'admpanel/complaints';
                }, 5000);
            }
        );
    }

    changeDone() {
        this.loading = true;

        if (this.editable) {
            this.$http.get(
                `/admpanel/ajax/complaints/changeDone/${this.complaint.id}/${this.complaint.done}`
            ).then(
                () => {
                    this.loading = false;
                    if (response.data.status === 'error') {
                        this.error = response.data.message;
                        $('html,body').animate({ scrollTop: 0 }, 'slow');

                        this.$timeout(() => {
                            this.error = false;
                        }, 5000);
                    } else {
                        this.success = this.translate.t('admpanel.complaints.statusOfComplaintHasBeenChanged');
                        $('html,body').animate({ scrollTop: 0 }, 'slow');

                        this.$timeout(() => {
                            this.success = false;
                        }, 5000);

                        this.complaint = response.data.complaint;
                    }
                },
                () => {
                    this.loading = false;

                    this.error = this.translate.t('admpanel.general.unexpectedErrorHasOccurred');
                    $('html,body').animate({ scrollTop: 0 }, 'slow');

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                }
            );
        }
    }

    acceptComplaint() {
        this.loading = true;

        this.$http.get(
            `/admpanel/ajax/complaints/acceptComplaint/${this.complaint.id}`
        ).then(
            (response) => {
                this.loading = false;
                if (response.data.status === 'error') {
                    this.error = response.data.message;
                    $('html,body').animate({ scrollTop: 0 }, 'slow');

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                } else {
                    this.success = this.translate.t('admpanel.complaints.complaintHasBeenMarkedAsAcknowledged');
                    $('html,body').animate({ scrollTop: 0 }, 'slow');

                    this.$timeout(() => {
                        this.success = false;
                    }, 5000);

                    this.complaint = response.data.complaint;
                }
            },
            () => {
                this.loading = false;

                this.error = this.translate.t('admpanel.general.unexpectedErrorHasOccurred');
                $('html,body').animate({ scrollTop: 0 }, 'slow');

                this.$timeout(() => {
                    this.error = false;
                }, 5000);
            }
        );
    }

    rejectComplaint() {
        this.loading = true;

        this.$http.get(
            `/admpanel/ajax/complaints/rejectComplaint/${this.complaint.id}`
        ).then(
            (response) => {
                this.loading = false;
                if (response.data.status === 'error') {
                    this.error = response.data.message;
                    $('html,body').animate({ scrollTop: 0 }, 'slow');

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                } else {
                    this.success = this.translate.t('admpanel.complaints.complaintHasBeenMarkedAsRejected');
                    $('html,body').animate({ scrollTop: 0 }, 'slow');

                    this.$timeout(() => {
                        this.success = false;
                    }, 5000);

                    this.complaint = response.data.complaint;
                }
            },
            () => {
                this.loading = false;

                this.error = this.translate.t('admpanel.general.unexpectedErrorHasOccurred');
                $('html,body').animate({ scrollTop: 0 }, 'slow');

                this.$timeout(() => {
                    this.error = false;
                }, 5000);
            }
        );
    }

    openAgainComplaint() {
        this.loading = true;

        this.$http.get(
            `/admpanel/ajax/complaints/openAgainComplaint/${this.complaint.id}`
        ).then(
            (response) => {
                this.loading = false;
                if (response.data.status === 'error') {
                    this.error = response.data.message;
                    $('html,body').animate({ scrollTop: 0 }, 'slow');

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                } else {
                    this.success = this.translate.t('admpanel.complaints.complaintHasBeenReopened');
                    $('html,body').animate({ scrollTop: 0 }, 'slow');

                    this.$timeout(() => {
                        this.success = false;
                    }, 5000);

                    this.complaint = response.data.complaint;
                }
            },
            () => {
                this.loading = false;

                this.error = this.translate.t('admpanel.general.unexpectedErrorHasOccurred');
                $('html,body').animate({ scrollTop: 0 }, 'slow');

                this.$timeout(() => {
                    this.error = false;
                }, 5000);
            }
        );
    }

    newOrder() {
        let complaint = this.complaint;
        let products = this.products;
        let shipments = this.shipments;

        this.modalService.showModal({
            template: complaintAdmModalNewOrderHtml,
            controller: complaintAdmModalNewOrderController,
            controllerAs: '$ctrl',
            preClose: (modal) => {
                modal.element.hide();
            },
            inputs: {
                complaint: complaint,
                products: products,
                shipments: shipments
            }
        }).then(modal => {
            modal.element.show();
            modal.closed.then(result => {
                if (result !== false) {
                    this.createOrder(result);
                }
            });
        });
    }

    createOrder(selected) {
        let products = selected.selectedProducts;
        let shipment = selected.selectedShipment;

        this.loading = true;

        this.$http.post('/admpanel/ajax/complaints/createOrder', {complaint_id: this.complaintId, products: products, shipment: shipment}, {
            headers: {'Content-Type': 'application/json'}
        }).then(
            (response) => {
                this.loading = false;
                if (response.data.status === 'error') {
                    this.error = response.data.message;
                    $('html,body').animate({ scrollTop: 0 }, 'slow');

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                } else {
                    this.success = this.translate.t('admpanel.complaints.orderHasBeenCreated');
                    $('html,body').animate({ scrollTop: 0 }, 'slow');

                    this.$timeout(() => {
                        this.success = false;
                    }, 5000);

                    this.createdOrders.unshift(response.data.order);
                }
            },
            () => {
                this.loading = false;

                this.error = this.translate.t('admpanel.general.unexpectedErrorHasOccurred');
                $('html,body').animate({ scrollTop: 0 }, 'slow');

                this.$timeout(() => {
                    this.error = false;
                    window.location.pathname = 'admpanel/complaints';
                }, 5000);
            }
        );
    }

    addNoteFile() {
        this.noteFiles.push({
            file: null
        });
    }

    addMessageFile() {
        this.messageFiles.push({
            file: null
        });
    }

    removeNoteFile(index) {
        this.noteFiles.splice(index, 1);
    }

    removeMessageFile(index) {
        this.messageFiles.splice(index, 1);
    }

    sendNote() {
        this.sendTicket(true);
    }

    sendTicket(adminNote = false) {


        const _this = this;

        let messageFilesErrors = [];

        let attachments = [];
        let message  = '';
        let admin = 0;


        if (adminNote) {
            attachments = this.noteFiles;
            message = this.note;
            admin = 1;
        } else {
            attachments = this.messageFiles;
            message = this.message;
        }

        if (message === '' || message  === null) {
            this.error = this.translate.t('admpanel.complaints.pleaseCompleteFieldWithMessage');
            $('html,body').animate({ scrollTop: 0 }, 'slow');

            return;
        }

        angular.forEach(attachments, function(value, key) {
            if (value.file !== null) {
                if (_this.allowedMimeTypes.indexOf(value.file.fileType) == -1) {
                    messageFilesErrors.push(this.translate.t('admpanel.complaints.attachment') + ' #' + (key + 1) + ': ' + this.translate.t('admpanel.complaints.allowedExtensions', {extensions: 'JPG, GIF, PNG, PDF, AI'}));
                }

                if (value.file.fileSize > 10000240) {
                    messageFilesErrors.push(this.translate.t('admpanel.complaints.attachment') + ' #' + (key + 1) + ': ' + this.translate.t('admpanel.complaints.maximumSizeOfUploadedFileIs', {extensions: '10'}));
                }
            }
        });
        if (messageFilesErrors.length > 0) {
            this.error = messageFilesErrors.join("\r\n");
            $('html,body').animate({ scrollTop: 0 }, 'slow');

            return;
        }

        this.loading = true;

        this.error = false;

        const formData = new FormData();

        formData.append('complaint_id', this.complaint.id);
        formData.append('message', message);
        formData.append('admin', admin);

        angular.forEach(attachments, function(value, key) {
            if (value.file !== null) {
                formData.append('files[]', value.file.fileFormData.get('file'));
            }
        });

        this.$http.post('/admpanel/ajax/complaints/sendTicket', formData, {
            transformRequest: angular.identity,
            headers: {'Content-Type': undefined}
        }).then(
            (response) => {
                this.loading = false;
                if (response.data.status === 'error') {
                    this.error = response.data.message;
                    $('html,body').animate({ scrollTop: 0 }, 'slow');

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                } else {
                    this.success = this.translate.t('admpanel.complaints.messageWasSent');
                    $('html,body').animate({ scrollTop: 0 }, 'slow');

                    this.$timeout(() => {
                        this.success = false;
                    }, 5000);

                    this.complaint.tickets.unshift(response.data.ticket);

                    this.message = null;
                    this.note = null;
                    this.messageFiles = [
                        {
                            file: null
                        }
                    ];

                    this.noteFiles = [
                        {
                            file: null
                        }
                    ];
                }
            },
            () => {
                this.loading = false;

                this.error = this.translate.t('admpanel.general.unexpectedErrorHasOccurred');
                $('html,body').animate({ scrollTop: 0 }, 'slow');

                this.$timeout(() => {
                    this.error = false;
                }, 5000);
            }
        );
    }

    changeReason() {
        this.loading = true;

        this.$http.post(
            '/admpanel/ajax/complaints/changeReason',
            {
                complaint_id: this.complaintId,
                complaint_reason_id: this.complaint.complaint_reason_id
            },
            {
                headers: {'Content-Type': 'application/json'}
            }
        ).then(
            (response) => {
                this.loading = false;
                if (response.data.status === 'error') {
                    this.error = response.data.message;
                    $('html,body').animate({ scrollTop: 0 }, 'slow');

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                } else {
                    this.success = 'Powód reklamacji został zmieniony.';
                    $('html,body').animate({ scrollTop: 0 }, 'slow');

                    this.$timeout(() => {
                        this.success = false;
                    }, 5000);
                }
            },
            () => {
                this.error = this.translate.t('admpanel.general.unexpectedErrorHasOccurred');
                $('html,body').animate({ scrollTop: 0 }, 'slow');

                this.$timeout(() => {
                    this.error = false;
                    window.location.pathname = 'admpanel/complaints';
                }, 5000);
            }
        );
    }
}

let complaintAdmComponent = {
    bindings: {
        'complaintId': '<'
    },
    template: complaintAdmHtml,
    controller: complaintAdmController
};

export default complaintAdmComponent;
